import { useEffect, useState } from 'react';
import { getDistrictJobs } from '../services/districtJobService';

// One shared poll of /jobs/district for the nav badge, the job card and the header
// intake pill, so three components cost one request every 15 s (none while hidden).
const POLL_MS = 15000;
const EMPTY = { jobs: [], running: [], recent: [], counts: { running: 0, queued: 0, paused: 0 }, intakePaused: false };

let state = EMPTY;
let timer = null;
const listeners = new Set();

async function refresh() {
  if (document.hidden) return;
  try {
    const { data } = await getDistrictJobs();
    const d = data?.data || {};
    state = {
      jobs: d.jobs || [],
      running: d.running || [],
      recent: d.recent || [],
      counts: d.counts || EMPTY.counts,
      intakePaused: Boolean(d.intake_paused),
    };
  } catch {
    state = EMPTY;
  }
  listeners.forEach((fn) => fn(state));
}

function onVisible() {
  if (!document.hidden) refresh();
}

export default function useLiveJobs() {
  const [value, setValue] = useState(state);

  useEffect(() => {
    listeners.add(setValue);
    if (listeners.size === 1) {
      refresh();
      timer = setInterval(refresh, POLL_MS);
      document.addEventListener('visibilitychange', onVisible);
    }
    return () => {
      listeners.delete(setValue);
      if (listeners.size === 0) {
        clearInterval(timer);
        document.removeEventListener('visibilitychange', onVisible);
      }
    };
  }, []);

  return value;
}
